<template>
  <div class="block paragraph-pic" :class="{ odd }">
    <div class="body" v-html="body" />
    <div class="media"><img :src="media" alt=""/></div>
  </div>
</template>

<script>
  export default {
    name: 'BlockParagraphPic',
    components: {
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      content: {
        type: Object,
        default: null,
      },
      odd: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {};
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      body() {
        return this.content?.body || null;
      },
      media() {
        const media = this.content?.media || null;
        if (media && media.length > 0) {
          return `${this.$b.contentUrl}/${media[0]?.full || media[0]?.path}`;
        }
        return null;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.block.paragraph-pic {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;

  &.odd {
    flex-direction: row-reverse;
  }

  @include screen-mobile {
    flex-direction: column-reverse;

    &.odd {
      flex-direction: column;
    }

  }

  & > .body {
    max-width: calc(50% - 20px);
    width: 100%;
    margin-bottom: 100px;

    p {
      margin: 20px 0;
      &:first-of-type { margin-top: 0; }
      &:last-of-type { margin-bottom: 0 }
    }

    @include screen-mobile {
      max-width: 100%;
      margin-bottom: 30px;
    }
  }

  & > .media {
    max-width: calc(50% - 20px);
    width: 100%;
    margin-bottom: 100px;
    text-align: right;

    @include screen-mobile {
      max-width: 100%;
      margin-bottom: 30px;
    }

    > img {
      display: inline-block;
      width: 100%;
      height: auto;
    }
  }
}
</style>
